
const colors = {

    backgroundRuukki: '#FC2516',
    backgroundLighterRuukki: '#FD665B',
    backgroundDarkerRuukki: '#CD1D10',

    backgroundPlannja: '#00594C',
    backgroundLighterPlannja: '#027B69',
    backgroundDarkerPlannja: '#00352D',

    backgroundPiristeel: '#009FE3',
    backgroundlighterPiristeel: '#48C1F5',
    backgroundDarkerPiristeel: '#006F9E',

    txtPrimary: '#333333',

    bgPrimary: '#F5F5F5',
    bgSecondary: '#FFFFFF',

    selectedBg: '#EAFFF4',
    unSelectedBg: '#F2FAFD',

    selectedBorder: '#88CA97',   
    unSelectedBorder: '#E5F5FC',
   
    buttonDisabled: '#6B6B6B',

    ErrorTxtMessage: '#D50000',
    ErrorBorder: '#CA1514',

    linkPrimary: '#FFB400',
    toolTip: '#015095'
}

export default colors;